export enum AnswerMutationSource {
  QUESTIONNAIRE = "QUESTIONNAIRE",
  ALIGNMENT = "ALIGNMENT",
}
